import { render, staticRenderFns } from "./BoxTaskRecommendations.vue?vue&type=template&id=02ab7e10&"
import script from "./BoxTaskRecommendations.vue?vue&type=script&lang=js&"
export * from "./BoxTaskRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./BoxTaskRecommendations.vue?vue&type=style&index=0&id=02ab7e10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QIcon,QCardSection,QTooltip,QSeparator,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QIcon,QCardSection,QTooltip,QSeparator,QInnerLoading,QSpinnerTail})
